import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var AssetsIcon = function AssetsIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "AssetsIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M3.803 2.904C4.146 2.344 4.765 2 5.432 2h5.136c.667 0 1.286.343 1.629.904l2.532 4.138c.361.59.361 1.326 0 1.916l-2.532 4.138c-.343.56-.962.904-1.629.904H5.432a1.91 1.91 0 0 1-1.629-.904L1.271 8.958a1.83 1.83 0 0 1 0-1.916zm1.629.751a.21.21 0 0 0-.181.1L2.718 7.895a.2.2 0 0 0 0 .212l2.533 4.138c.038.063.107.1.18.1h5.137a.21.21 0 0 0 .181-.1l2.533-4.138a.2.2 0 0 0 0-.212l-2.533-4.138a.21.21 0 0 0-.18-.1z",
      clipRule: "evenodd"
    })
  }));
};

export { AssetsIcon };
